"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getQueryStringParams_1 = require("./getQueryStringParams");
var getBaseUrl_1 = require("./getBaseUrl");
var buildQueryStringParams_1 = require("./buildQueryStringParams");
function setQueryStringParams(params, url) {
    url = url || window.location.href;
    var urlParams = getQueryStringParams_1.getQueryStringParams(url) || {};
    for (var key in params) {
        if (params.hasOwnProperty(key)) {
            urlParams[key] = params[key];
        }
    }
    return getBaseUrl_1.getBaseURL(url) + buildQueryStringParams_1.buildQueryStringParams(urlParams);
}
exports.setQueryStringParams = setQueryStringParams;
